const UUID =
  /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
let cachedSessionId = null;

function sessionId() {
  if (cachedSessionId) return cachedSessionId;
  try {
    const stored = window.sessionStorage.getItem("ngel_sid");
    if (stored && stored.length <= 64) return (cachedSessionId = stored);
    const fresh = window.crypto.randomUUID();
    window.sessionStorage.setItem("ngel_sid", fresh);
    return (cachedSessionId = fresh);
  } catch {
    return undefined;
  }
}

export function protectedResearch(path, name = "") {
  return path.startsWith("/vote-ready") || name.startsWith("readiness_");
}

// A browser context, never an authenticated person or a cross-device identity.
export function getAnalyticsIdentity(name = "") {
  if (typeof window === "undefined") return {};
  const identity = { sessionId: sessionId() };
  if (protectedResearch(window.location.pathname, name)) return identity;
  try {
    const stored = window.localStorage.getItem("ngel_vid");
    const visitorId =
      stored && UUID.test(stored) ? stored : window.crypto.randomUUID();
    if (visitorId !== stored)
      window.localStorage.setItem("ngel_vid", visitorId);
    return { ...identity, visitorId };
  } catch {
    return identity;
  }
}

export function getSignupIdentity() {
  if (
    typeof window === "undefined" ||
    protectedResearch(window.location.pathname)
  )
    return {};
  const { sessionId: signupSessionId, visitorId: signupVisitorId } =
    getAnalyticsIdentity();
  return { signupSessionId, signupVisitorId };
}
